import React, { useState, useEffect } from "react";
import { AppBar, Toolbar } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Navbar from "./Navbar";
import ToggleButton from "./ToggleIcon";
import styles from "./Navbar.module.css";
import NavbarSlider from "./../NavBarSlider/NavbarSlider";
import {connect} from "react-redux";

const NavIndex = (props) => {
  const [open, setopen] = useState(false);
  const [value, setValue] = useState(0);
  const handleToggle = () => {
    setopen(!open);
  };
  const handleClose = () => {
    setopen(!open);
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const {auth} = props.user;
  return (
    <>
     {auth?<AppBar className={styles.appbar} position="fixed">
        <Toolbar className={styles.toolbar}>
          {matches ? <ToggleButton handleToggle={handleToggle} /> : <Navbar />}
        </Toolbar>
      </AppBar>:""}
      <NavbarSlider
        open={matches ? open : false}
        handleToggle={handleToggle}
        handleClose={handleClose}
        value={value}
        setValue={setValue}
      />
    </>
  );
};

const mapStateWithProps = (state)=>(
  { user : state.user}
)
export default connect(mapStateWithProps)(NavIndex);
